module.exports = __webpack_public_path__ + "img/27.ed5560b3.webp";